import { useSearchParams } from "react-router-dom";
import { Grid, Stack, Typography } from "@mui/material";
import { Loader } from "../../components/Loader";
import ProductCard from "../../components/ProductCard";
import Button from "../../components/Button";
import { SearchProductFragment } from "../../generated/storefront";
import { colors } from "../../theme";
import { Frame } from "../../types/product";

const ProductTab = ({
  products,
  loading,
  loadingMore,
  searchQs,
  isMobileScreen,
  loadMore,
  loadOtherProducts,
  hasMore,
  showOtherProductsButton,
  selectedFrame,
}: {
  products: SearchProductFragment[];
  loading: boolean;
  loadingMore: boolean;
  searchQs: string;
  isMobileScreen: boolean;
  loadMore: () => void;
  loadOtherProducts: () => void;
  hasMore: boolean;
  showOtherProductsButton: boolean;
  selectedFrame: Frame;
}) => {
  const [searchParams] = useSearchParams();

  return loading && !products.length ? (
    <Loader />
  ) : products.length === 0 ? (
    <Typography variant="h3" align="center">
      No products found for "{searchQs}"
    </Typography>
  ) : (
    <Stack gap={4} paddingBottom={3}>
      <Grid container spacing={{ xs: 1, md: 2 }} rowGap={{ xs: 4, md: 9 }}>
        {products.map((product) => (
          <Grid item xs={6} md={3} xl={3} xxl={2} xxxl={1.5} key={product.id}>
            <ProductCard
              product={product}
              indent={isMobileScreen}
              frame={selectedFrame}
              canvas={searchParams.get("material") === "canvas"}
            />
          </Grid>
        ))}
        <Grid item xs={6} md={3} xl={3} xxl={2} xxxl={1.5}>
          {showOtherProductsButton ? (
            <Stack
              width="100%"
              height="100%"
              alignItems="center"
              justifyContent="center"
              padding={2}
              bgcolor={colors.grey02}
              minHeight={{ xs: 260, md: 300 }}
            >
              <Button onClick={loadOtherProducts}>Show more</Button>
            </Stack>
          ) : null}
        </Grid>
      </Grid>
      {loadingMore ? (
        <Loader />
      ) : hasMore ? (
        <Stack width="100%" alignItems="center">
          <Button onClick={loadMore}>Load more</Button>
        </Stack>
      ) : null}
    </Stack>
  );
};

export default ProductTab;
